import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp, INoRowsOverlayAngularComp } from "ag-grid-angular";
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { NzSkeletonComponent } from "ng-zorro-antd/skeleton";
import { NoDataFoundComponent } from "../no-data-found/no-data-found.component";
import { NoDataComponent } from "../no-data/no-data.component";

@Component({
  selector: 'app-custom-no-data-found',
  standalone: true,
  imports: [SkeletonLoaderComponent, NzSkeletonComponent, NoDataFoundComponent, NoDataComponent],
  template: `
      <app-no-data-found></app-no-data-found>
  `,
  styles: [``]
})
export class CustomNoDataFound implements INoRowsOverlayAngularComp {
  agInit(params: INoRowsOverlayParams): void {
  }

  refresh(params: INoRowsOverlayParams): void {
  }

}
